import React, { FC, useState } from 'react';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';

interface Props {
  configurations: string;
}
export const ProviderDetailsConfigurations: FC<Props> = ({ configurations }) => {

  const [modalState, setModalState] = useState<IModalWindow>({
    isOpen: false
  });

  let json = '';
  if (configurations) {
    const parsedJSON = JSON.parse(configurations);
    json = JSON.stringify(parsedJSON, null, 4);
  }

  const onCloseModal = (): void => setModalState(prevState => ({ ...prevState, isOpen: false }));

  const openModal = (): void => {

    setModalState({
      isOpen: true,
      modalTitle: 'Configurations',
      contentClassName: 'd-block pb-1',
      isRightSideModal: true,
      size: 'xs',
      content: (
        <div className="sense-script m-6">
					<pre className="code-area p-5">
						{json}
					</pre>
        </div>
      )
    });
  };

  return (
    <>
      <ButtonComponent
        additionalClass="fs-6 me-10 no-letter-spacing mt-5"
        buttonName="Configurations"
        buttonType={BUTTON_TYPE.FAKE_LINK}
        onButtonClick={openModal}
        withoutUnderline={true}
        isDisabled={!configurations}
        cypressAttribute="configurations-button"

      />

      <ModalWindow
        {...modalState}
        onClose={onCloseModal}
      />
    </>
  );
};